<div class="col-lg-12" [ngClass]="{'hr-line-dashed':widget.showLine}">
  
</div>